import React from 'react';
const EditReportModalBody = ({
  onReportEditSubmit,
  onReportEditModalToggle,
  reportComment,
  onReportCommentChange,
  isReportErrorMessageDisplay = 'd-none',
  reportErrorMessage = '',
}) => {
  return (
    <div className='card-block'>
      <form>
        <div className='row'>
          <div className='col-sm-12 margin_bottom_10'>
            <textarea
              id='comment'
              name='reportComment'
              rows='6'
              className='form-control'
              placeholder='Content..'
              onChange={e => onReportCommentChange(e)}
              value={reportComment}
            />
            <span className={isReportErrorMessageDisplay + ' text-danger'}>
              {reportErrorMessage}
            </span>
          </div>
        </div>
        <div className='row'>
          <div className='col-sm-12 d-flex'>
            <button
              onClick={e => onReportEditSubmit(e)}
              className='btn btn-primary active pointer_class'
            >
              {' '}
              {'Update'}
            </button>

            <button
              type='button'
              className='btn btn-danger active pointer_class margin_left_10'
              onClick={() => onReportEditModalToggle()}
            >
              {' '}
              {'Cancel'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
export default EditReportModalBody;



// WEBPACK FOOTER //
// ./src/views/ESG/Dashboard/EditReportModalBody.jsx